import { render, staticRenderFns } from "./ReturnForCorrectionsDialog.vue?vue&type=template&id=77190a9a&"
import script from "./ReturnForCorrectionsDialog.vue?vue&type=script&lang=js&"
export * from "./ReturnForCorrectionsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports